import { useRef } from 'react'
import UploadFileItem from './UploadFileItem'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

const UploadFile = ({
  files,
  setFiles,
  filesPreview,
  setFilesPreview,
  setIsModal,
  setDocumentDescription,
}) => {
  const hiddenFileInput = useRef(null)
  const file_number = useSelector((state) => state.FileNumber.value)
  console.log('file_number:', file_number)
  const validExt = '.png, .pdf, .jpeg, .jpg'

  const fileExtValidate = (fileUploaded) => {
    const filePath = fileUploaded?.name
    const getFileExt = filePath.substring(filePath.lastIndexOf('.') + 1).toLowerCase()
    const pos = validExt.indexOf(getFileExt)
    if (pos < 0) {
      return false
    } else {
      return true
    }
  }
  const fileNames = files?.map((item) => item.name)
  const handleClick = (event) => {
    hiddenFileInput.current.click()
  }
  const handleChange = (event) => {
    const fileUploaded = event.target.files[0]
    if (fileUploaded && fileExtValidate(fileUploaded)) {
      if (fileNames.includes(fileUploaded?.name) === false) {
        setFiles([...files, fileUploaded])
        setFilesPreview([...filesPreview, URL.createObjectURL(event.target.files[0])])
      } else {
        setIsModal({ type: 'ownerFileType', active: true })
        hiddenFileInput.current.value = null
        // setTimeout(() => {
        //   setIsModal({ type: '', active: false });
        // }, 2300);
      }
    } else {
      setIsModal({ type: 'file', active: true })
      hiddenFileInput.current.value = null
      //   setTimeout(() => {
      //     setIsModal({ type: '', active: false });
      //   }, 2300);
    }
  }

  const handleDelete = (index) => {
    let newFiles = files?.filter((item, i) => i !== index)
    let newFilesPreview = filesPreview?.filter((item, i) => i !== index)
    setFiles(newFiles)
    setFilesPreview(newFilesPreview)
  }

  return (
    <>
      <div
        style={{
          paddingLeft: '1.4rem',
          color: '#285843',
          fontSize: '0.9rem',
          marginTop: '0.9rem',
          fontWeight: 600,
        }}
      >
        <div style={{ marginRight: '0.5rem' }}>Belgeler</div>
        <p
          style={{
            fontSize: '0.6rem',
          }}
        >
          {setDocumentDescription}
        </p>
      </div>

      <div
        className='hide-scrollbar'
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
          marginLeft: '1.25rem',
          marginRight: '0.5rem',
          overflow: 'scroll',
          gap: '0.5rem',
        }}
      >
        {[...Array(file_number).keys()].map((_, index) => {
          return (
            <UploadFileItem
              total={file_number}
              key={index}
              files={files}
              filesPreview={filesPreview}
              hiddenFileInput={hiddenFileInput}
              handleClick={handleClick}
              handleChange={handleChange}
              handleDelete={() => handleDelete(index)}
              index={index}
            />
          )
        })}
      </div>
    </>
  )
}

UploadFile.propTypes = {
  files: PropTypes.array,
  filesPreview: PropTypes.array,
  setFiles: PropTypes.func,
  setFilesPreview: PropTypes.func,
  setIsModal: PropTypes.func,
}

export default UploadFile
